export default "__VITE_ASSET__DAYJjtA0__"